export interface KeyValuePair<K, V> {
  key: K;
  value: V;
}
